
export const URL_TICKET:string				= "/ticket";
export const URL_LOGININFO:string			= "/logininfo";
export const URL_LOGIN:string				= "/login/login";
export const URL_MASTER_MSTCD:string		= "/master/mstcd";
export const URL_MASTER_MEDIA:string		= "/master/media";
export const URL_MASTER_GAZO_H:string		= "/master/gazoh";
export const URL_MASTER_OWNER:string		= "/master/mstowner";
export const URL_MASTER_KONYU:string		= "/master/konyu";
export const URL_MASTER_ADDR:string			= "/master/mstaddr";
export const URL_DASHBORD:string			= "/dashbord/view";
export const URL_DASHBORD_THREAD:string		= "/dashbord/thread";
export const URL_PRODUCT_LIST:string		= "/product/shiplist";
export const URL_PRODUCT_EDITMENU:string	= "/product/editmenu";
export const URL_PRODUCT_EDITFUNE:string	= "/product/editfune";
export const URL_PRODUCT_FUNEINFO:string	= "/product/funeinfo";
export const URL_PRODUCT_KAKAKU:string		= "/product/kakaku";
export const URL_PRODUCT_EDITEQUIP:string	= "/product/editequip";
export const URL_PRODUCT_EDITRECOMMEND:string	= "/product/editrecommend";
export const URL_PRODUCT_EDITMEDIA:string	= "/product/editmedia";
export const URL_PRODUCT_EDITBLOCK:string	= "/product/editblock";
export const URL_PRODUCT_EDITMOVIE:string	= "/product/editmovie";
export const URL_PRODUCT_EDITBLOCKMEDIA:string	= "/product/editblockmedia";
export const URL_PRODUCT_EDITOWNER:string	= "/product/editowner";
export const URL_PRODUCT_EDITKONYU:string	= "/product/editkonyu";
export const URL_PRODUCT_EDITTANTO:string	= "/product/edittanto";
export const URL_PRODUCT_EDITFILE:string	= "/product/editfile";
export const URL_PRODUCT_AUCTION:string		= "/product/auction";
export const URL_PRODUCT_REPORT:string		= "/product/report";

export const URL_DATA_OWNER:string			= "/data/owner";
export const URL_DATA_EXPORT:string			= "/data/export";
export const URL_DATA_SUMMARY:string		= "/data/summary";
export const URL_DATA_CODE:string			= "/data/code";
export const URL_DATA_CATALOG:string		= "/data/catalog";
export const URL_DATA_TANTO:string			= "/data/tanto";
export const URL_DATA_SMSLOG:string			= "/data/smslog";

export const URL_REPORT_KAKAKU:string		= "/report/kakaku";
export const URL_REPORT_ACCESS:string		= "/report/access";
export const URL_REPORT_INVOICE:string		= "/report/invoice";

